import { LoadableLazy } from '@confluence/loadable';

export const PageTreeAfterIconLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageTreeAfterIcon" */ './PageTreeAfterIcon.tsx'))
			.PageTreeAfterIcon,
});
